var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <form id=\"passwordResetForm\" role=\"form\">\r\n        <h2>"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"M") : depth0)) != null ? lookupProperty(stack1,"resetPassword") : stack1), depth0))
    + "</h2>\r\n        <div class=\"form-group\">\r\n            <input id=\"newPassword\" type=\"password\" class=\"form-control\" name=\"newPassword\" />\r\n            <span class=\"help-block\" id=\"error\"></span>\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <input id=\"passwordConfirm\" type=\"password\" class=\"form-control\" name=\"passwordConfirm\" />\r\n            <span class=\"help-block\" id=\"error\"></span>\r\n        </div>\r\n        <button id=\"submitBtn\" type=\"submit\" class=\"btn btn-lg btn-success ladda-button\" data-style=\"zoom-in\">"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"M") : depth0)) != null ? lookupProperty(stack1,"ok") : stack1), depth0))
    + "</button>\r\n    </form>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"h4 text-danger\">\r\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"M") : depth0)) != null ? lookupProperty(stack1,"resetPasswordFail") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"reset-password-column1\">\r\n</div>\r\n<div class=\"reset-password-column2\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"userId") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":21,"column":11}}})) != null ? stack1 : "")
    + "</div>\r\n";
},"useData":true});